import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../Components/Footer/footer";
import NewsletterSection from "../Components/Landing/newsletter";

export default function HydroponicMasterclass() {
  const REDIRECT = "https://www.hydroponicmasterclass.com/";
  const [counter, setCounter] = useState(10);


  useEffect(() => {
    // Countdown
    const interval = setInterval(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    // Redirect at 0
    const timer = setTimeout(() => {
      window.location.href = REDIRECT;
    }, 10000);

    // Cleanup
    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="page">
      {/* ---------------- SEO ---------------- */}
      <Helmet>
        <title>Hydroponic Masterclass | Kryzen Biotech</title>
        <meta
          name="description"
          content="Join the Hydroponic Masterclass by Kryzen Biotech. Learn commercial hydroponics, greenhouse automation, business planning, and modern agri-tech in India's #1 expert-led training."
        />
        <meta
          name="keywords"
          content="hydroponic masterclass, hydroponic webinar, hydroponics training, kryzen webinar, agri webinar, commercial hydroponics course"
        />
      </Helmet>

      {/* ---------------- HERO SECTION ---------------- */}
   
      <section className="py-6 bg-light">
      <div className="text-center">
        <h1 className="display-3 fw-bold d-none d-lg-block d-md-block display-3 display-md-3 display-lg-2">Hydroponic Masterclass</h1>
        <h1 className="fw-bold text-dark d-lg-none d-md-none mb-3  display-6 display-md-3 display-lg-2">
        Hydroponic Masterclass
        </h1>
        <p className="text-secondary fs-2 mt-2">
          A complete beginner-to-expert masterclass on modern hydroponics,
          smart farming & commercial agriculture.
        </p>

        {/* 🔥 Countdown message */}
        <p className="mt-3 fs-4 fw-semibold text-success">
          Redirecting you to the masterclass in {counter} seconds...
        </p>

        <button
          className="btn btn-success btn-lg mt-3"
          onClick={() => (window.location.href = REDIRECT)}
        >
          🔥 Join the Masterclass Now
        </button>
      </div>
    </section>

      <NewsletterSection />
      <Footer />
    </div>
  );
}
